export default "__VITE_ASSET__Cc1t8ErP__"